import { render, staticRenderFns } from "./PreFooterInfo.vue?vue&type=template&id=20320468&"
import script from "./PreFooterInfo.vue?vue&type=script&lang=js&"
export * from "./PreFooterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports